/**
 * Viewdata voor de poort-patronen-overlay op het mandala-wiel (de Mandala-tab in
 * de chart-editor). Puur presentational: de page bepaalt welke lagen aan staan en
 * levert de kruispoort-paren; het wiel tekent de verbindingen uit de vaste
 * poort-metadata (kanalen + programmeringspartners) — het muteert de chart niet.
 *
 * Zelfde inputpatroon als {@link HdMandalaMoonTransitViewData} /
 * {@link HdMandalaLocksKeysViewData}: `null` = laag niet renderen.
 */
export interface HdMandalaPatternsViewData {
  /** Kanaal-links (blauw, gebogen koorden) tekenen tussen de poorten van elk kanaal. */
  readonly showChannelLinks: boolean;
  /** Programmeringspartner-links (rood): elke poort naar haar mandala-tegenover — rechte diameters. */
  readonly showPartnerLinks: boolean;
  /**
   * Incarnatiekruis-diameters van de geladen chart: elk paar is één as
   * (Zon↔Aarde van personality of design). Leeg = geen kruis tonen (bv. lege
   * chart of laag uit).
   */
  readonly incarnationCrossPairs: readonly (readonly [number, number])[];

  /**
   * Life cross-diameters van de geladen chart: elk paar is één as (Noordknoop↔
   * Zuidknoop van personality of design). Zelfde vorm als het incarnatiekruis,
   * maar voor de nodale poorten. Leeg = niet tonen.
   */
  readonly lifeCrossPairs: readonly (readonly [number, number])[];
}

/**
 * Toggle-state van de Mandala-tab in de configurator. De page vertaalt dit +
 * de geladen chart naar {@link HdMandalaPatternsViewData} voor het wiel.
 */
export interface HdMandalaPatternOptions {
  readonly showChannelLinks: boolean;
  readonly showPartnerLinks: boolean;
  readonly showIncarnationCross: boolean;
  readonly showLifeCross: boolean;
}

export const HD_MANDALA_PATTERN_OPTIONS_DEFAULT: HdMandalaPatternOptions = {
  showChannelLinks: false,
  showPartnerLinks: false,
  showIncarnationCross: false,
  showLifeCross: false,
};
